import { State_update, Types_Msg$4, State_init } from "../ThreeDocs.Client.StateMachine.Crud/CrudComponent.js";
import { InvitationsUpdateArgs, CustomShared_get_replyToEmail_, CustomShared_get_currentRoles_, CustomShared_get_packages_, CustomShared, InvitationsCrudConfig_invitationVmModelConfig, InvitationsCrudConfig_invitationVmViewConfig, InvitationsCrudConfig_generalViewLayoutConfig } from "./InvitationsCrudConfig.js";
import { ofArray, singleton, tryHead, empty } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Msg, Model } from "./InvitationsTypes.js";
import { Cmd_batch, Cmd_none, Cmd_map } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { Permission, isAllowed } from "../ThreeDocs.Models/Security.js";
import { Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { securedAuthApi, securedApi } from "../Api.js";
import { some, defaultArg } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { error } from "../ThreeDocs.SharedUI/Toast.js";
import { ErrorMessage_get_describe } from "../ThreeDocs.Models/Api/Api.js";
import { Shared_CrudInbound$2 } from "../ThreeDocs.Client.StateMachine.Crud/SharedCrud.js";
import { Optic_Set, Optic_Set_op_HatEquals_2170E4F5 } from "../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";
import { Security_AuthErrorMessage_get_describe } from "../fable_modules/Webbler.Models.1.3.1/Api.fs.js";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.25.0/Seq.js";

export function init() {
    const patternInput = State_init(InvitationsCrudConfig_generalViewLayoutConfig(InvitationsCrudConfig_invitationVmViewConfig.viewListItemConfig.listColumns, InvitationsCrudConfig_invitationVmModelConfig.isSameItem), InvitationsCrudConfig_invitationVmViewConfig, InvitationsCrudConfig_invitationVmModelConfig, new CustomShared(empty(), empty(), undefined));
    return [new Model(patternInput[0]), Cmd_map((Item) => (new Msg(8, [Item])), patternInput[1])];
}

export function update(token, userInfo, msg, model) {
    let msg_7, matchValue_1, pId_1, msg_11, msg_12;
    switch (msg.tag) {
        case 2:
            if (isAllowed(new Permission(25, []))(userInfo.roles)) {
                return [model, Cmd_OfAsyncWith_either((x) => {
                    AsyncHelpers_start(x);
                }, securedApi(token).getAllInvitationsForPractice, defaultArg(tryHead(userInfo.userData.Practices), "00000000-0000-0000-0000-000000000000"), (Item_6) => (new Msg(3, [Item_6])), (Item_7) => (new Msg(0, [Item_7])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 3:
            if (msg.fields[0].tag === 1) {
                return [model, error(ErrorMessage_get_describe()(msg.fields[0].fields[0]))];
            }
            else {
                return [model, singleton((dispatch_4) => {
                    dispatch_4(new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(0, [msg.fields[0].fields[0]])])]));
                })];
            }
        case 4:
            return [model, Cmd_OfAsyncWith_either((x_1) => {
                AsyncHelpers_start(x_1);
            }, securedApi(token).getAllPackagesForPractice, msg.fields[0], (Item_11) => (new Msg(5, [Item_11])), (Item_12) => (new Msg(0, [Item_12])))];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [model, error(ErrorMessage_get_describe()(msg.fields[0].fields[0]))];
            }
            else {
                return [model, (msg_7 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_packages_())(msg.fields[0].fields[0])])])])), singleton((dispatch_5) => {
                    dispatch_5(msg_7);
                }))];
            }
        case 6:
            switch (msg.fields[0].tag) {
                case 0:
                    return [model, singleton((dispatch_6) => {
                        dispatch_6(new Msg(2, []));
                    })];
                case 3:
                    return [model, (matchValue_1 = tryHead(userInfo.userData.Practices), (matchValue_1 != null) ? ((matchValue_1 === msg.fields[0].fields[0]) ? ((pId_1 = matchValue_1, singleton((dispatch_7) => {
                        dispatch_7(new Msg(4, [msg.fields[0].fields[0]]));
                    }))) : Cmd_none()) : Cmd_none())];
                case 6:
                    return [model, (userInfo.id === msg.fields[0].fields[0]) ? Cmd_OfAsyncWith_either((x_2) => {
                        AsyncHelpers_start(x_2);
                    }, securedAuthApi(token).getUserInfo, undefined, (Item_16) => (new Msg(7, [Item_16])), (Item_17) => (new Msg(0, [Item_17]))) : Cmd_none()];
                default:
                    return [model, Cmd_none()];
            }
        case 7:
            if (msg.fields[0].tag === 1) {
                return [model, error(Security_AuthErrorMessage_get_describe()(msg.fields[0].fields[0]))];
            }
            else {
                return [model, Cmd_batch(ofArray([(msg_11 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_currentRoles_())(msg.fields[0].fields[0].roles)])])])), singleton((dispatch_8) => {
                    dispatch_8(msg_11);
                })), (msg_12 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_replyToEmail_())(msg.fields[0].fields[0].userData.ReplyToEmail)])])])), singleton((dispatch_9) => {
                    dispatch_9(msg_12);
                }))]))];
            }
        case 0: {
            console.error(some(`Error: ${msg.fields[0]}`));
            return [model, Cmd_none()];
        }
        case 8:
            if (msg.fields[0].tag === 1) {
                if (msg.fields[0].fields[0].tag === 1) {
                    return [model, error("An unexpected error occurred. Please try again.")];
                }
                else {
                    return [model, error(ErrorMessage_get_describe()(msg.fields[0].fields[0].fields[0]))];
                }
            }
            else {
                const patternInput = State_update(new InvitationsUpdateArgs(token, defaultArg(tryHead(userInfo.userData.Practices), "00000000-0000-0000-0000-000000000000")), msg.fields[0], model.InvitationCrudModel);
                return [new Model(patternInput[0]), Cmd_map((Item_24) => (new Msg(8, [Item_24])), patternInput[1])];
            }
        default:
            return [model, Cmd_batch(toList(delay(() => append(singleton_1(singleton((dispatch) => {
                dispatch(new Msg(2, []));
            })), delay(() => {
                let msg_2;
                return append(singleton_1((msg_2 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_currentRoles_())(userInfo.roles)])])])), singleton((dispatch_1) => {
                    dispatch_1(msg_2);
                }))), delay(() => {
                    let msg_3;
                    return append(singleton_1((msg_3 = (new Msg(8, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_replyToEmail_())(userInfo.userData.ReplyToEmail)])])])), singleton((dispatch_2) => {
                        dispatch_2(msg_3);
                    }))), delay(() => {
                        let msg_4;
                        const matchValue = tryHead(userInfo.userData.Practices);
                        return (matchValue == null) ? singleton_1(Cmd_none()) : singleton_1((msg_4 = (new Msg(4, [matchValue])), singleton((dispatch_3) => {
                            dispatch_3(msg_4);
                        })));
                    }));
                }));
            })))))];
    }
}

